export default "__VITE_ASSET__65f5e1a8__"